import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { GetTenderDetailedInfoQueryResponse, GetTenderDetailedInfoQueryParams } from "../../types/GetTenderDetailedInfo";

/**
     * @link /api/purchase-tenders/private/v1/tender/view_detail-info
     */
export async function getTenderDetailedInfo (params?: GetTenderDetailedInfoQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<GetTenderDetailedInfoQueryResponse>["data"]> {
    const { data: resData } = await client<GetTenderDetailedInfoQueryResponse>({
        method: "get",
        url: `/api/purchase-tenders/private/v1/tender/view_detail-info`,
        params,
        ...options
    });
    
    return resData;
};